import React, { useCallback, useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';

import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';

function SoapNotePopup({ soapId, handleReload, handleClose }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const [soapData, setSoapData] = useState('');
  useEffect(() => {
    (async () => {
      const response = await post('api/patient/progressNote/openSoapForm', {
        soapId: soapId,
      });
      if (response.status === 200) {
        setSoapData(response?.data?.soapNonStructuralData || '');
      }
    })();
  }, [soapId]);

  const onContentBlur = useCallback((e) => {
    const sanitizedContent = DOMPurify.sanitize(e.target.innerHTML);
    setSoapData(sanitizedContent);
  }, []);

  const handleSaveSoapNotPopup = () => {
    if (!soapData) {
      setUiMessage('err', 'Please enter soap note.');
      return;
    }
    try {
      (async () => {
        const response = await post(
          'api/patient/progressNote/soapStrProcessViaNebula',
          {
            soapId: soapId,
            soapNonStructural: soapData,
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          if (response?.data?.status === 'success') {
            handleReload('soapnote');
            dispatch(
              setRenderFormData({
                data: { soapStr: response.data.renderDesc },
                type: 'soapnote',
              })
            );
            handleClose();
          }
        }
      })();
    } catch (error) {
      setUiMessage('err', error);
    }
  };

  return (
    <div className="modalBackground">
      <div className="soap-note-popup">
        <div className="soap-note-blk-hdr">
          <span className="clear5">Progress Note:</span>
          <span className="right bold cursor" onClick={handleClose}>
            X
          </span>
        </div>

        <div className="soapTextarea-block">
          <div
            contentEditable={true}
            onBlur={onContentBlur}
            dangerouslySetInnerHTML={{ __html: soapData }}
            className="soapTextarea aiblock"
          />
        </div>
        <div className="soap-notepopup-blk-ftr">
          <span onClick={handleClose} className="button-cancel clear-right">
            Cancel
          </span>
          <span
            onClick={() => handleSaveSoapNotPopup()}
            className="button-submit clear-left"
          >
            Save
          </span>
        </div>
      </div>
    </div>
  );
}

export default SoapNotePopup;
